export const WORDS = [
  "ababa",
  "abaca",
  "abada",
  "abadi",
  "abajo",
  "abano",
  "abasi",
  "abate",
  "abati",
  "abece",
  "abeja",
  "abete",
  "abeto",
  "abiar",
  "abiso",
  "abita",
  "abono",
  "abozo",
  "abril",
  "abrir",
  "abubo",
  "abuje",
  "abuso",
  "acabe",
  "acabo",
  "acaso",
  "acato",
  "acebo",
  "acedo",
  "acera",
  "acero",
  "aceto",
  "acezo",
  "aceña",
  "achin",
  "achis",
  "acial",
  "aciar",
  "acije",
  "acilo",
  "acion",
  "aclla",
  "acodo",
  "acose",
  "acoso",
  "acroe",
  "acroy",
  "actea",
  "actor",
  "acure",
  "acuse",
  "acuto",
  "acuti",
  "adala",
  "adaza",
  "adema",
  "ademe",
  "adiar",
  "adiva",
  "adive",
  "adios",
  "adoba",
  "adobe",
  "adobo",
  "adoro",
  "adral",
  "adrar",
  "aduar",
  "adufe",
  "aduja",
  "adula",
  "aduro",
  "afate",
  "afear",
  "afiar",
  "afijo",
  "afilo",
  "afino",
  "aforo",
  "afufa",
  "agace",
  "agace",
  "agami",
  "agave",
  "agnus",
  "agora",
  "agote",
  "agraz",
  "agrio",
  "agror",
  "agras",
  "aguar",
  "aguay",
  "aguai",
  "agudo",
  "aguja",
  "aguti",
  "aguin",
  "aguio",
  "ahogo",
  "ahora",
  "ahilo",
  "ahina",
  "ahito",
  "airar",
  "aireo",
  "airon",
  "ajada",
  "ajado",
  "ajaja",
  "ajear",
  "ajebe",
  "ajeno",
  "ajero",
  "ajete",
  "ajipa",
  "ajobo",
  "ajote",
  "ajuar",
  "ajuno",
  "alaco",
  "alada",
  "alado",
  "alafa",
  "alaju",
  "alala",
  "alama",
  "alano",
  "alaui",
  "alazo",
  "albar",
  "albor",
  "albur",
  "albin",
  "alcea",
  "alcor",
  "aldea",
  "alear",
  "alece",
  "aleda",
  "aleja",
  "alelo",
  "aleli",
  "alema",
  "alero",
  "aleta",
  "aleto",
  "aleve",
  "aleya",
  "alezo",
  "alfar",
  "alfil",
  "alfiz",
  "alfoz",
  "algar",
  "algia",
  "algol",
  "algun",
  "alhoz",
  "aliar",
  "alias",
  "alier",
  "alifa",
  "alijo",
  "alioj",
  "aliso",
  "aliño",
  "aljez",
  "aljor",
  "allen",
  "almea",
  "almez",
  "almud",
  "aloes",
  "aloja",
  "alora",
  "alosa",
  "aloya",
  "alpes",
  "altar",
  "altea",
  "altor",
  "aluda",
  "aludo",
  "alzar",
  "amado",
  "amago",
  "amaro",
  "amate",
  "amaño",
  "ambos",
  "ambon",
  "ameba",
  "amelo",
  "ameno",
  "ameos",
  "amiba",
  "amibo",
  "amida",
  "amiga",
  "amigo",
  "amina",
  "amino",
  "amiri",
  "amito",
  "amole",
  "amomo",
  "amplo",
  "ampon",
  "amura",
  "amuso",
  "anabi",
  "anaco",
  "anafe",
  "anamu",
  "anana",
  "anata",
  "ancha",
  "ancho",
  "ancla",
  "ancua",
  "ancon",
  "andar",
  "andas",
  "andel",
  "anden",
  "andon",
  "anear",
  "anejo",
  "aneto",
  "anexo",
  "anglo",
  "angor",
  "angra",
  "anime",
  "anito",
  "anion",
  "anjeo",
  "anona",
  "ansia",
  "antes",
  "antia",
  "antro",
  "anual",
  "anuro",
  "aocar",
  "aojar",
  "aonio",
  "aorta",
  "aovar",
  "apaño",
  "apear",
  "apego",
  "apena",
  "apero",
  "apiri",
  "apnea",
  "apodo",
  "apoyo",
  "apres",
  "aptar",
  "apure",
  "apuro",
  "aquel",
  "aqueo",
  "aquel",
  "arabo",
  "arabi",
  "arada",
  "arado",
  "arana",
  "arasa",
  "araza",
  "araña",
  "araño",
  "arcar",
  "arcea",
  "archa",
  "archi",
  "arcen",
  "arcon",
  "arder",
  "ardid",
  "ardil",
  "ardor",
  "arduo",
  "areca",
  "arena",
  "arepa",
  "arete",
  "arfar",
  "arfil",
  "argel",
  "argos",
  "argot",
  "argue",
  "argan",
  "argen",
  "argon",
  "argue",
  "aries",
  "arije",
  "arijo",
  "arilo",
  "arlar",
  "armar",
  "armos",
  "armon",
  "arnes",
  "aroca",
  "aroma",
  "aromo",
  "arpar",
  "arpeo",
  "arpia",
  "arpon",
  "arras",
  "arraz",
  "arreo",
  "arria",
  "arroz",
  "arrui",
  "artal",
  "artos",
  "aruño",
  "arzon",
  "asado",
  "ascio",
  "ascua",
  "asear",
  "asilo",
  "asina",
  "asmar",
  "asnal",
  "asomo",
  "aspar",
  "aspic",
  "aspro",
  "aster",
  "astil",
  "astro",
  "astur",
  "asuso",
  "atabe",
  "atado",
  "atajo",
  "ataud",
  "atear",
  "ateje",
  "atino",
  "atlas",
  "atoar",
  "atoba",
  "atole",
  "atona",
  "atora",
  "atoro",
  "atril",
  "atrio",
  "atroz",
  "atras",
  "atufo",
  "audaz",
  "audio",
  "augur",
  "aunar",
  "aupar",
  "ausol",
  "autor",
  "autan",
  "avaro",
  "avati",
  "avena",
  "aveza",
  "aviar",
  "avica",
  "aviso",
  "avion",
  "avugo",
  "axial",
  "axila",
  "ayaco",
  "ayate",
  "ayear",
  "ayora",
  "ayote",
  "ayuda",
  "ayuga",
  "ayuno",
  "ayuso",
  "azada",
  "azala",
  "azaro",
  "azcon",
  "azeri",
  "azoar",
  "azoro",
  "azote",
  "aztor",
  "azuda",
  "aereo",
  "aillo",
  "ainas",
  "añada",
  "añejo",
  "añero",
  "añino",
  "añoja",
  "añojo",
  "añoso",
  "aullo",
  "abaco",
  "absit",
  "acana",
  "acaro",
  "acere",
  "acido",
  "acimo",
  "acoro",
  "acueo",
  "acula",
  "afaca",
  "afilo",
  "afono",
  "agape",
  "agata",
  "agora",
  "alabe",
  "alaga",
  "alala",
  "alalo",
  "alamo",
  "album",
  "alica",
  "alimo",
  "aloes",
  "alula",
  "alveo",
  "amago",
  "amalo",
  "ambar",
  "anade",
  "angel",
  "angor",
  "anima",
  "animo",
  "anodo",
  "ansar",
  "anulo",
  "apice",
  "apodo",
  "arabe",
  "arbol",
  "arbor",
  "ardea",
  "arido",
  "arula",
  "asaro",
  "ascar",
  "aspid",
  "aster",
  "atico",
  "atomo",
  "atona",
  "atono",
  "aureo",
  "avaro",
  "avido",
  "azimo",
  "babel",
  "babeo",
  "bable",
  "babor",
  "bache",
  "bacon",
  "bacan",
  "bacia",
  "bacin",
  "badal",
  "badea",
  "badil",
  "badan",
  "baden",
  "bafle",
  "bagar",
  "bagre",
  "bahai",
  "bahia",
  "baifa",
  "baifo",
  "baila",
  "baile",
  "bajar",
  "bajel",
  "bajez",
  "bajio",
  "bajon",
  "balaj",
  "balar",
  "balay",
  "balda",
  "balde",
  "baldo",
  "balea",
  "baleo",
  "balsa",
  "balso",
  "balto",
  "balin",
  "balon",
  "bamba",
  "bambu",
  "banal",
  "banas",
  "banca",
  "bance",
  "banco",
  "banda",
  "bando",
  "banir",
  "banjo",
  "bantu",
  "banyo",
  "banzo",
  "baque",
  "barba",
  "barbo",
  "barca",
  "barco",
  "barda",
  "bardo",
  "baria",
  "baril",
  "bario",
  "barra",
  "barro",
  "barza",
  "baria",
  "baron",
  "basal",
  "basar",
  "basca",
  "basis",
  "basna",
  "basta",
  "baste",
  "basto",
  "batea",
  "batel",
  "bateo",
  "batey",
  "batik",
  "batir",
  "batan",
  "batin",
  "bausa",
  "bauza",
  "bayal",
  "bayon",
  "bayua",
  "bazar",
  "baida",
  "bañar",
  "bañil",
  "beata",
  "beato",
  "beber",
  "becar",
  "bedel",
  "befar",
  "befre",
  "begum",
  "beige",
  "bejin",
  "belez",
  "belfo",
  "belga",
  "belio",
  "bello",
  "belua",
  "belen",
  "bemba",
  "bembo",
  "bemol",
  "beodo",
  "beori",
  "beque",
  "berbi",
  "berma",
  "berra",
  "berro",
  "berta",
  "berza",
  "beron",
  "besar",
  "betel",
  "betun",
  "beudo",
  "bezar",
  "bezon",
  "biaza",
  "bical",
  "bicha",
  "biche",
  "bicho",
  "bicos",
  "bidon",
  "biela",
  "bijao",
  "bijol",
  "bilao",
  "bilis",
  "billa",
  "bilma",
  "bimba",
  "binar",
  "bingo",
  "binza",
  "biota",
  "birla",
  "birlo",
  "birli",
  "bisar",
  "bisel",
  "biste",
  "bitar",
  "bitor",
  "bizco",
  "bizma",
  "bizna",
  "blavo",
  "bleda",
  "bledo",
  "bloca",
  "blues",
  "blusa",
  "boato",
  "bocal",
  "bocel",
  "bocha",
  "boche",
  "bocho",
  "bocio",
  "bocoy",
  "bocin",
  "bocon",
  "bodon",
  "bofia",
  "bogar",
  "bohio",
  "boina",
  "boira",
  "bojar",
  "bojeo",
  "bolar",
  "boldo",
  "boleo",
  "bolla",
  "bollo",
  "bolsa",
  "bolso",
  "bolin",
  "bolon",
  "bomba",
  "bombo",
  "bombe",
  "bonga",
  "bongo",
  "bongo",
  "bonzo",
  "boque",
  "boqui",
  "borda",
  "borde",
  "bordo",
  "boria",
  "borla",
  "borne",
  "borni",
  "borra",
  "borro",
  "borto",
  "bosar",
  "bosta",
  "botar",
  "botor",
  "botin",
  "boton",
  "boxeo",
  "boyal",
  "boyar",
  "bozal",
  "bozon",
  "boîte",
  "braco",
  "braga",
  "brama",
  "brasa",
  "brava",
  "bravo",
  "braza",
  "brazo",
  "braña",
  "brear",
  "breca",
  "brega",
  "brete",
  "breva",
  "breve",
  "brezo",
  "breña",
  "brial",
  "briba",
  "brida",
  "briol",
  "brisa",
  "briza",
  "broca",
  "broma",
  "bromo",
  "brota",
  "brote",
  "broto",
  "broza",
  "brugo",
  "bruja",
  "brujo",
  "bruma",
  "brumo",
  "bruno",
  "bruta",
  "bruto",
  "bruza",
  "bruño",
  "buaro",
  "bubon",
  "bucal",
  "buceo",
  "buces",
  "buche",
  "bucio",
  "bucle",
  "budin",
  "buega",
  "buena",
  "bueno",
  "buera",
  "bufar",
  "bufeo",
  "bufia",
  "bufos",
  "bufon",
  "bugle",
  "buhio",
  "buido",
  "bujeo",
  "bujia",
  "bular",
  "bulbo",
  "bulda",
  "bulla",
  "bulto",
  "bulin",
  "bulon",
  "bunio",
  "buque",
  "buque",
  "burda",
  "burdo",
  "burel",
  "bureo",
  "burga",
  "burgo",
  "buril",
  "burla",
  "burra",
  "burro",
  "burio",
  "busca",
  "busco",
  "busto",
  "buten",
  "butia",
  "buzar",
  "buzos",
  "buzon",
  "biter",
  "borax",
  "boreo",
  "boxer",
  "cabal",
  "caber",
  "cabio",
  "cable",
  "cabra",
  "cabro",
  "cabas",
  "cacao",
  "cacea",
  "caceo",
  "cacha",
  "cache",
  "cacho",
  "cache",
  "cachu",
  "cacle",
  "cacto",
  "cacuy",
  "cacan",
  "cafiz",
  "cafre",
  "cagar",
  "cague",
  "cagon",
  "cahiz",
  "caico",
  "caima",
  "caire",
  "caite",
  "cajel",
  "cajin",
  "cajon",
  "calar",
  "calca",
  "calce",
  "calco",
  "calda",
  "caldo",
  "caler",
  "calla",
  "calle",
  "callo",
  "calma",
  "calmo",
  "calor",
  "calta",
  "calva",
  "calvo",
  "calza",
  "calzo",
  "calan",
  "cales",
  "calon",
  "camal",
  "camao",
  "camba",
  "cambo",
  "camio",
  "campa",
  "campo",
  "camon",
  "canal",
  "cande",
  "candi",
  "caney",
  "canez",
  "canga",
  "cania",
  "canil",
  "canje",
  "canoa",
  "canon",
  "canso",
  "canta",
  "cante",
  "canto",
  "cantu",
  "caoba",
  "caobo",
  "capar",
  "capaz",
  "capea",
  "capel",
  "capeo",
  "capia",
  "capio",
  "cappa",
  "capuz",
  "capin",
  "capon",
  "caqui",
  "carao",
  "carau",
  "caray",
  "carau",
  "carba",
  "carca",
  "carda",
  "cardo",
  "carea",
  "carel",
  "careo",
  "carey",
  "carga",
  "cargo",
  "caria",
  "cario",
  "cariz",
  "carla",
  "carlo",
  "carme",
  "carne",
  "carne",
  "carpa",
  "carpe",
  "carpo",
  "carra",
  "carro",
  "carta",
  "carvi",
  "caron",
  "casal",
  "casar",
  "casca",
  "casco",
  "casia",
  "casis",
  "caspa",
  "casta",
  "casto",
  "cason",
  "catar",
  "cateo",
  "catey",
  "catos",
  "catre",
  "catan",
  "catin",
  "caton",
  "cauba",
  "cauca",
  "cauce",
  "cauda",
  "cauje",
  "caula",
  "cauno",
  "cauri",
  "cauro",
  "causa",
  "cauto",
  "cauza",
  "cavar",
  "cavia",
  "cavan",
  "cavio",
  "cavon",
  "cayan",
  "cazar",
  "cazuz",
  "cazon",
  "caido",
  "cañal",
  "cañar",
  "cañeo",
  "cañon",
  "ceaja",
  "ceajo",
  "cebar",
  "cebil",
  "cebra",
  "cebro",
  "cebti",
  "cebon",
  "cecal",
  "ceceo",
  "ceder",
  "cedro",
  "cefea",
  "cegar",
  "cegua",
  "ceiba",
  "ceibo",
  "cejar",
  "celar",
  "celda",
  "celfo",
  "celia",
  "cella",
  "cello",
  "celta",
  "celan",
  "cembo",
  "cenal",
  "cenar",
  "cenca",
  "cenco",
  "cenia",
  "cenit",
  "censo",
  "cepti",
  "cequi",
  "cerca",
  "cerco",
  "cerda",
  "cerdo",
  "cerio",
  "cerna",
  "cerne",
  "cerno",
  "cerpa",
  "cerra",
  "cerro",
  "ceron",
  "cesar",
  "cesio",
  "cesta",
  "cesto",
  "cetil",
  "cetme",
  "cetra",
  "cetre",
  "cetro",
  "cetis",
  "ceuti",
  "ceñar",
  "ceñir",
  "chaca",
  "chaco",
  "chaco",
  "chaja",
  "chala",
  "chale",
  "chale",
  "chama",
  "chana",
  "chane",
  "chano",
  "chana",
  "chapa",
  "chape",
  "chapo",
  "chapo",
  "chata",
  "chato",
  "chauz",
  "chavo",
  "chavo",
  "chaya",
  "chayo",
  "chaza",
  "chazo",
  "chaul",
  "checa",
  "checo",
  "cheje",
  "chele",
  "cheli",
  "chelo",
  "chepa",
  "chepe",
  "chepo",
  "chero",
  "cheso",
  "chiar",
  "chica",
  "chico",
  "chifa",
  "chile",
  "chimo",
  "china",
  "chino",
  "chine",
  "chipa",
  "chipe",
  "chipa",
  "chipe",
  "chira",
  "chiri",
  "chisa",
  "chist",
  "chita",
  "chite",
  "chito",
  "chiva",
  "chivo",
  "chiza",
  "choba",
  "choca",
  "choco",
  "choca",
  "choco",
  "chofe",
  "chola",
  "cholo",
  "chopa",
  "chope",
  "chopo",
  "chori",
  "choro",
  "chota",
  "chote",
  "choto",
  "chova",
  "choya",
  "choza",
  "chozo",
  "chuca",
  "chuco",
  "chufa",
  "chula",
  "chulo",
  "chule",
  "chuna",
  "chupa",
  "chupe",
  "chupo",
  "churo",
  "chute",
  "chuto",
  "chuva",
  "chuyo",
  "chuza",
  "chuzo",
  "chuña",
  "chuño",
  "ciani",
  "ciato",
  "cibal",
  "cicca",
  "ciclo",
  "cidra",
  "cidro",
  "cieca",
  "ciego",
  "cielo",
  "ciemo",
  "cieno",
  "cifra",
  "cigua",
  "cilio",
  "cilla",
  "cimar",
  "cimba",
  "cimia",
  "cimpa",
  "cinca",
  "cinco",
  "cinia",
  "cinta",
  "cinto",
  "circa",
  "circe",
  "circo",
  "cirio",
  "cirro",
  "cisca",
  "cisco",
  "cisma",
  "cisne",
  "cista",
  "citar",
  "citra",
  "civil",
  "claco",
  "clapa",
  "clara",
  "claro",
  "clase",
  "clava",
  "clave",
  "clavo",
  "clero",
  "clica",
  "clima",
  "clise",
  "cloro",
  "clota",
  "clown",
  "clube",
  "coana",
  "coati",
  "cobea",
  "cobez",
  "cobil",
  "cobla",
  "cobra",
  "cobre",
  "cobro",
  "cocal",
  "cocar",
  "cocer",
  "cocha",
  "coche",
  "cochi",
  "cocho",
  "cocol",
  "cocui",
  "cocuy",
  "codal",
  "codeo",
  "codin",
  "codon",
  "coevo",
  "cofia",
  "cofre",
  "cofin",
  "coger",
  "cogon",
  "coima",
  "coime",
  "coine",
  "coipo",
  "coito",
  "cojal",
  "cojin",
  "cojon",
  "colar",
  "coleo",
  "colla",
  "colme",
  "colmo",
  "colon",
  "color",
  "colpa",
  "colpe",
  "colza",
  "colin",
  "colon",
  "comal",
  "comba",
  "combo",
  "comer",
  "comis",
  "comto",
  "comun",
  "conca",
  "conde",
  "conga",
  "congo",
  "congo",
  "conta",
  "coona",
  "copal",
  "copar",
  "copec",
  "copeo",
  "copey",
  "copia",
  "copla",
  "copra",
  "copto",
  "copin",
  "copon",
  "coque",
  "coqui",
  "coral",
  "corar",
  "coras",
  "corbe",
  "corca",
  "corco",
  "corda",
  "corea",
  "coreo",
  "corla",
  "corma",
  "corno",
  "corpa",
  "corps",
  "corra",
  "corro",
  "corsa",
  "corso",
  "corse",
  "corta",
  "corte",
  "corto",
  "corva",
  "corvo",
  "corza",
  "corzo",
  "coran",
  "corua",
  "coser",
  "cospe",
  "costa",
  "coste",
  "costo",
  "cotar",
  "cotin",
  "coton",
  "cotua",
  "coxal",
  "coxis",
  "coyol",
  "coyan",
  "coñac",
  "coñon",
  "crack",
  "craso",
  "craza",
  "crear",
  "credo",
  "creer",
  "crema",
  "crema",
  "crepe",
  "crepe",
  "cresa",
  "creso",
  "creta",
  "criar",
  "criba",
  "cribo",
  "crica",
  "crida",
  "croar",
  "croco",
  "cromo",
  "crono",
  "cross",
  "croza",
  "cruce",
  "cruda",
  "crudo",
  "cruel",
  "cruza",
  "cruor",
  "cuaba",
  "cuaco",
  "cuado",
  "cuajo",
  "cuasi",
  "cuate",
  "cuati",
  "cubil",
  "cucar",
  "cucha",
  "cuche",
  "cuchi",
  "cucho",
  "cuche",
  "cuchi",
  "cucuy",
  "cueca",
  "cueco",
  "cuera",
  "cuero",
  "cuete",
  "cueto",
  "cueva",
  "cueza",
  "cuezo",
  "cuica",
  "cuico",
  "cuida",
  "cuido",
  "cuija",
  "cuina",
  "cuino",
  "cuita",
  "cujon",
  "cular",
  "culas",
  "culle",
  "culpa",
  "culto",
  "culen",
  "culon",
  "cumba",
  "cumbo",
  "cumbe",
  "cumpa",
  "cunar",
  "cuneo",
  "cuota",
  "cuple",
  "cupon",
  "cural",
  "curar",
  "curco",
  "curda",
  "curdo",
  "curia",
  "curie",
  "curio",
  "curre",
  "curro",
  "curry",
  "cursi",
  "curso",
  "curto",
  "curul",
  "curva",
  "curvo",
  "curia",
  "cusca",
  "cusco",
  "cusir",
  "cusma",
  "cuspa",
  "cutio",
  "cutir",
  "cutis",
  "cutre",
  "cuzco",
  "cuzma",
  "cuñal",
  "cuñar",
  "calao",
  "caliz",
  "caseo",
  "cavea",
  "cereo",
  "cesar",
  "coleo",
  "comic",
  "copec",
  "cumel",
  "cuneo",
  "cuter",
  "dable",
  "dacha",
  "dacio",
  "dador",
  "dahir",
  "dahir",
  "daifa",
  "dajao",
  "dalgo",
  "dalia",
  "dalla",
  "dalle",
  "dalla",
  "damil",
  "dance",
  "dandi",
  "dango",
  "danta",
  "dante",
  "danto",
  "danza",
  "danes",
  "daqui",
  "dardo",
  "dares",
  "darga",
  "datar",
  "dauco",
  "dauda",
  "dañar",
  "debda",
  "debdo",
  "deber",
  "debla",
  "debut",
  "decir",
  "decor",
  "dedal",
  "dedeo",
  "dedil",
  "deesa",
  "dejar",
  "delco",
  "delga",
  "delio",
  "dello",
  "delta",
  "demas",
  "dende",
  "denso",
  "deque",
  "derbi",
  "desca",
  "desde",
  "deseo",
  "desga",
  "deste",
  "desus",
  "deuda",
  "deudo",
  "deñar",
  "diado",
  "diana",
  "diaño",
  "dicaz",
  "dicha",
  "dicho",
  "diego",
  "diesi",
  "dieta",
  "digno",
  "dijes",
  "dimes",
  "dimir",
  "dinar",
  "diodo",
  "diosa",
  "dioso",
  "dique",
  "disco",
  "dison",
  "diuca",
  "divan",
  "diñar",
  "dobla",
  "doble",
  "doblo",
  "docto",
  "dogal",
  "dogma",
  "dogre",
  "dolar",
  "doler",
  "dolor",
  "domar",
  "dombo",
  "donar",
  "donde",
  "doneo",
  "dopar",
  "doral",
  "dorar",
  "dorio",
  "dorna",
  "dorso",
  "dosel",
  "dosis",
  "dotal",
  "dotar",
  "dotor",
  "draba",
  "draga",
  "drago",
  "drama",
  "drino",
  "driza",
  "droga",
  "drope",
  "drupa",
  "drusa",
  "druso",
  "dseda",
  "dubda",
  "dubio",
  "ducal",
  "ducas",
  "ducha",
  "ducho",
  "ducto",
  "dudar",
  "duela",
  "duelo",
  "dueto",
  "dueña",
  "dueño",
  "dular",
  "dulce",
  "dulia",
  "dundo",
  "dupla",
  "duplo",
  "duque",
  "durar",
  "datil",
  "debil",
  "diada",
  "docil",
  "dolar",
  "ebrio",
  "echar",
  "edema",
  "edrar",
  "efebo",
  "efeto",
  "efeta",
  "egeno",
  "egida",
  "eguar",
  "ejido",
  "ejion",
  "ejote",
  "elami",
  "elato",
  "elche",
  "elemi",
  "elepe",
  "eleto",
  "elite",
  "ellos",
  "elote",
  "empos",
  "enano",
  "encia",
  "encia",
  "eneal",
  "enema",
  "enero",
  "enojo",
  "ensay",
  "enteo",
  "entre",
  "entro",
  "enves",
  "envio",
  "eolio",
  "epoda",
  "epodo",
  "epoto",
  "epoxi",
  "equis",
  "eraje",
  "erala",
  "erbio",
  "ercer",
  "erebo",
  "ergio",
  "erial",
  "erina",
  "erizo",
  "ermar",
  "erraj",
  "errar",
  "error",
  "eruto",
  "escoa",
  "escas",
  "esnob",
  "espay",
  "espia",
  "espin",
  "esqui",
  "estar",
  "estay",
  "estil",
  "estol",
  "estor",
  "estos",
  "estro",
  "estio",
  "etano",
  "etapa",
  "etilo",
  "etneo",
  "etnia",
  "etolo",
  "etusa",
  "eubeo",
  "evohe",
  "exida",
  "extra",
  "ebano",
  "efeta",
  "eforo",
  "egida",
  "elego",
  "emulo",
  "enula",
  "epica",
  "epico",
  "epoca",
  "ester",
  "estos",
  "esula",
  "etica",
  "etico",
  "etimo",
  "etneo",
  "exito",
  "exodo",
  "fabla",
  "fabro",
  "facer",
  "facha",
  "facto",
  "facon",
  "faena",
  "fagot",
  "faino",
  "fajar",
  "fajol",
  "fajin",
  "fajon",
  "falaz",
  "falca",
  "falce",
  "falda",
  "falla",
  "fallo",
  "falsa",
  "falso",
  "falta",
  "falte",
  "falto",
  "falua",
  "fanal",
  "fango",
  "faqui",
  "farad",
  "farda",
  "fardo",
  "faria",
  "farol",
  "farpa",
  "farra",
  "farro",
  "farsa",
  "farte",
  "faron",
  "fasta",
  "fasto",
  "fatal",
  "fator",
  "fatuo",
  "fauna",
  "fauno",
  "favor",
  "fañar",
  "febeo",
  "feble",
  "fecal",
  "fecha",
  "fecho",
  "feeza",
  "feliz",
  "felpa",
  "felpo",
  "felon",
  "felus",
  "femar",
  "fenal",
  "fenda",
  "fendi",
  "fenol",
  "feral",
  "feraz",
  "feria",
  "ferir",
  "fermi",
  "feroz",
  "ferra",
  "ferre",
  "ferro",
  "ferry",
  "festa",
  "fetal",
  "fetor",
  "fetua",
  "feten",
  "feudo",
  "feuco",
  "fiado",
  "fibra",
  "ficar",
  "ficha",
  "fideo",
  "fiemo",
  "fiera",
  "fiero",
  "figle",
  "figon",
  "fijar",
  "filar",
  "filfa",
  "filis",
  "fillo",
  "filme",
  "filon",
  "final",
  "finar",
  "finca",
  "finir",
  "finta",
  "fines",
  "fique",
  "firma",
  "firme",
  "fisco",
  "fisga",
  "fisto",
  "fisan",
  "fizar",
  "fizon",
  "flaco",
  "flama",
  "flash",
  "flato",
  "flavo",
  "flaon",
  "fleco",
  "fleja",
  "fleje",
  "flema",
  "fleme",
  "fleta",
  "flete",
  "flexo",
  "flojo",
  "flora",
  "flota",
  "flote",
  "fluir",
  "flujo",
  "fluor",
  "fobia",
  "focal",
  "focha",
  "fogon",
  "foiso",
  "folga",
  "folgo",
  "folio",
  "folla",
  "foluz",
  "folia",
  "fomes",
  "fonda",
  "fondo",
  "fonil",
  "fonio",
  "fonje",
  "foque",
  "foral",
  "foras",
  "forca",
  "forja",
  "forma",
  "forno",
  "forro",
  "forte",
  "fosal",
  "fosar",
  "fosco",
  "fosor",
  "foton",
  "frada",
  "frade",
  "fraga",
  "frase",
  "fredo",
  "freno",
  "fresa",
  "freso",
  "frete",
  "freza",
  "freir",
  "freon",
  "frior",
  "frisa",
  "friso",
  "frita",
  "frito",
  "froga",
  "frote",
  "fruir",
  "fruta",
  "fruto",
  "fucia",
  "fudre",
  "fuego",
  "fuera",
  "fuero",
  "fuesa",
  "fufar",
  "fugar",
  "fugaz",
  "fugir",
  "fuina",
  "fular",
  "fulla",
  "fumar",
  "funda",
  "fundo",
  "furia",
  "furor",
  "furto",
  "fusca",
  "fusco",
  "fusil",
  "fusor",
  "fusta",
  "fuste",
  "fusto",
  "futre",
  "fuñar",
  "facil",
  "fasol",
  "femur",
  "fenix",
  "fosil",
  "fovea",
  "fucar",
  "fusil",
  "futil",
  "gaban",
  "gacel",
  "gacha",
  "gacho",
  "gache",
  "gachi",
  "gacho",
  "gafar",
  "gaita",
  "galce",
  "galea",
  "galgo",
  "galio",
  "galla",
  "gallo",
  "galop",
  "galan",
  "gales",
  "galon",
  "galua",
  "gamba",
  "gamma",
  "gamon",
  "ganar",
  "ganga",
  "gansa",
  "ganso",
  "ganta",
  "gante",
  "garay",
  "garba",
  "garbo",
  "garfa",
  "gario",
  "garla",
  "garlo",
  "garma",
  "garpa",
  "garra",
  "garza",
  "garzo",
  "garua",
  "gasto",
  "gason",
  "gatas",
  "gauss",
  "gavia",
  "gayar",
  "gañil",
  "gañir",
  "gañan",
  "gañin",
  "gañon",
  "gelfe",
  "gemir",
  "genio",
  "genol",
  "gente",
  "geoda",
  "gerbo",
  "gesta",
  "gesto",
  "gibao",
  "gibar",
  "gibon",
  "gilvo",
  "ginea",
  "girar",
  "giste",
  "glase",
  "glayo",
  "gleba",
  "glera",
  "glifo",
  "globo",
  "glosa",
  "glose",
  "gluma",
  "gneis",
  "gnomo",
  "gobio",
  "goben",
  "gocha",
  "gocho",
  "godeo",
  "gofio",
  "goles",
  "golfa",
  "golfo",
  "golpe",
  "gomar",
  "gomel",
  "gomer",
  "gomia",
  "gonce",
  "gongo",
  "gorda",
  "gordo",
  "gorga",
  "gorja",
  "gorra",
  "gorro",
  "goteo",
  "goton",
  "gozar",
  "gozne",
  "gozon",
  "grada",
  "grado",
  "grafo",
  "graja",
  "grajo",
  "grama",
  "gramo",
  "grana",
  "grand",
  "grano",
  "grant",
  "grapa",
  "grasa",
  "graso",
  "grata",
  "grato",
  "grava",
  "grave",
  "greba",
  "greca",
  "greco",
  "greda",
  "green",
  "grelo",
  "greno",
  "greña",
  "grial",
  "grida",
  "grifa",
  "grifo",
  "grija",
  "grill",
  "grima",
  "gripa",
  "gripe",
  "gripo",
  "grisa",
  "grisu",
  "grita",
  "grito",
  "groar",
  "grojo",
  "gromo",
  "grosa",
  "groso",
  "gruir",
  "gruja",
  "grumo",
  "grupa",
  "grupo",
  "gruta",
  "guaba",
  "guabo",
  "guaba",
  "guaca",
  "guaco",
  "guado",
  "guaja",
  "guaje",
  "guaja",
  "guala",
  "guala",
  "guama",
  "guamo",
  "guama",
  "guano",
  "guape",
  "guapo",
  "guara",
  "guaro",
  "guara",
  "guasa",
  "guaso",
  "guata",
  "guate",
  "guaya",
  "guayo",
  "gubia",
  "gueto",
  "guiar",
  "guido",
  "guifa",
  "guija",
  "guijo",
  "guiri",
  "guisa",
  "guiso",
  "guita",
  "guito",
  "guiño",
  "guion",
  "gular",
  "gules",
  "gumia",
  "gurdo",
  "gusto",
  "guzgo",
  "guzla",
  "galea",
  "galeo",
  "guero",
  "gueña",
  "guila",
  "guira",
  "guiro",
  "guito",
  "habar",
  "haber",
  "habiz",
  "habla",
  "habon",
  "habus",
  "hacer",
  "hacha",
  "hache",
  "hacho",
  "hacia",
  "hacan",
  "hadar",
  "hafiz",
  "haiga",
  "halar",
  "halda",
  "halon",
  "hamez",
  "hampa",
  "hampo",
  "hanzo",
  "harca",
  "harda",
  "harem",
  "harma",
  "harpa",
  "harre",
  "harto",
  "haren",
  "haron",
  "hasta",
  "haute",
  "havar",
  "hayal",
  "hebra",
  "heben",
  "hecha",
  "hecho",
  "heder",
  "hedor",
  "helar",
  "helio",
  "helor",
  "henal",
  "henar",
  "henil",
  "henry",
  "heria",
  "heril",
  "herir",
  "herma",
  "herpe",
  "herre",
  "hertz",
  "heteo",
  "hevea",
  "heñir",
  "hiato",
  "hidra",
  "hielo",
  "hiena",
  "hiera",
  "hiero",
  "higui",
  "hilar",
  "hilio",
  "himen",
  "himno",
  "hinco",
  "hindi",
  "hindu",
  "hipar",
  "hippy",
  "hirco",
  "hirma",
  "hisca",
  "hitar",
  "hiton",
  "hiñir",
  "hobby",
  "hogar",
  "holco",
  "holan",
  "honda",
  "hondo",
  "hongo",
  "honor",
  "honra",
  "hopeo",
  "hoque",
  "horca",
  "horco",
  "horda",
  "horma",
  "horno",
  "horre",
  "horro",
  "hosco",
  "hospa",
  "hoste",
  "hotel",
  "hoyar",
  "hozar",
  "huaca",
  "huaco",
  "hucha",
  "hucho",
  "hucia",
  "hueca",
  "hueco",
  "huego",
  "huera",
  "huero",
  "huesa",
  "hueso",
  "hueva",
  "huevo",
  "huich",
  "huida",
  "huido",
  "huifa",
  "huira",
  "huiro",
  "hulla",
  "hulte",
  "humar",
  "humil",
  "humor",
  "humus",
  "hurra",
  "hurto",
  "huron",
  "husma",
  "husmo",
  "hutia",
  "haber",
  "habil",
  "hapax",
  "heroe",
  "hiper",
  "humil",
  "husar",
  "ibero",
  "icaco",
  "ichal",
  "icono",
  "ictus",
  "ideal",
  "idear",
  "igual",
  "iguar",
  "ijada",
  "ijuju",
  "ileso",
  "ilion",
  "ilota",
  "iluso",
  "imada",
  "imela",
  "impar",
  "impla",
  "impio",
  "inane",
  "india",
  "indio",
  "ingle",
  "ingre",
  "inope",
  "input",
  "inter",
  "invar",
  "irado",
  "irani",
  "irupe",
  "islam",
  "isleo",
  "islan",
  "isoca",
  "istmo",
  "itria",
  "itrio",
  "izada",
  "izado",
  "izote",
  "ibero",
  "ibice",
  "icono",
  "idolo",
  "igneo",
  "ileon",
  "index",
  "inter",
  "iride",
  "italo",
  "jable",
  "jabon",
  "jacal",
  "jacer",
  "jadeo",
  "jagua",
  "jaiba",
  "jaima",
  "jajay",
  "jalar",
  "jalda",
  "jalde",
  "jaldo",
  "jalea",
  "jaleo",
  "jalma",
  "jalon",
  "jamar",
  "jamba",
  "jambo",
  "jamas",
  "jamon",
  "japon",
  "jaque",
  "jaque",
  "jaral",
  "jarca",
  "jarda",
  "jarra",
  "jarro",
  "jasar",
  "jaspe",
  "jateo",
  "jatib",
  "jaudo",
  "jauja",
  "jaula",
  "jauto",
  "jayan",
  "jedar",
  "jeito",
  "jejen",
  "jeliz",
  "jemal",
  "jeque",
  "jerbo",
  "jerez",
  "jerga",
  "jerpa",
  "jesus",
  "jetar",
  "jeton",
  "jibia",
  "jifia",
  "jigue",
  "jijas",
  "jijeo",
  "jimia",
  "jimio",
  "jinda",
  "jiote",
  "jipio",
  "jirel",
  "jiron",
  "jisca",
  "jitar",
  "jiñar",
  "jobar",
  "joder",
  "jofor",
  "jolin",
  "jondo",
  "jonio",
  "jopeo",
  "jorco",
  "jorfe",
  "jorga",
  "jorge",
  "jorro",
  "joule",
  "joven",
  "joyel",
  "joyon",
  "juana",
  "jubon",
  "judas",
  "judia",
  "judio",
  "juego",
  "juera",
  "jueza",
  "jugar",
  "jujeo",
  "julia",
  "julio",
  "jumil",
  "junco",
  "junio",
  "junta",
  "junto",
  "junza",
  "jurar",
  "jurco",
  "jurel",
  "justa",
  "justo",
  "jutia",
  "jutia",
  "juvia",
  "juñir",
  "kappa",
  "karma",
  "karst",
  "kayak",
  "kirie",
  "koala",
  "koine",
  "kopek",
  "krill",
  "kurdo",
  "kefir",
  "labeo",
  "labia",
  "labio",
  "labor",
  "labra",
  "labro",
  "lacha",
  "lacho",
  "lacio",
  "lacra",
  "lacre",
  "lacon",
  "ladeo",
  "ladra",
  "ladon",
  "lagar",
  "lagua",
  "laico",
  "laido",
  "lamer",
  "lamia",
  "lampa",
  "lampo",
  "lamin",
  "lanar",
  "lance",
  "landa",
  "lande",
  "lando",
  "langa",
  "lanza",
  "lanio",
  "lapso",
  "lapon",
  "laque",
  "larda",
  "lardo",
  "larga",
  "largo",
  "larra",
  "larva",
  "lasca",
  "lasto",
  "lasun",
  "lataz",
  "latir",
  "latin",
  "laton",
  "lauda",
  "laude",
  "laudo",
  "launa",
  "lauro",
  "lauto",
  "lavar",
  "laxar",
  "layar",
  "lazar",
  "lañar",
  "lecha",
  "leche",
  "lecho",
  "ledon",
  "legal",
  "legar",
  "legra",
  "legua",
  "legui",
  "legon",
  "leila",
  "leima",
  "lejas",
  "lejos",
  "lejia",
  "lejio",
  "lembo",
  "lempo",
  "leman",
  "lente",
  "lento",
  "lenon",
  "leona",
  "lepra",
  "lerda",
  "lerdo",
  "lesna",
  "leste",
  "letal",
  "leteo",
  "letra",
  "leton",
  "leude",
  "leudo",
  "levar",
  "lezda",
  "lezna",
  "lezne",
  "leida",
  "leido",
  "leñar",
  "liana",
  "liara",
  "liaza",
  "libar",
  "libio",
  "libra",
  "libre",
  "libro",
  "liban",
  "libon",
  "liceo",
  "licio",
  "licor",
  "lidia",
  "lidio",
  "liego",
  "lieva",
  "lieve",
  "ligar",
  "light",
  "ligio",
  "ligue",
  "ligur",
  "ligon",
  "lijar",
  "lilac",
  "lilao",
  "lilio",
  "limar",
  "limbo",
  "limen",
  "limon",
  "linao",
  "linar",
  "lince",
  "linde",
  "lindo",
  "linfa",
  "linio",
  "linon",
  "lioso",
  "lipes",
  "lipis",
  "lipon",
  "liria",
  "lirio",
  "liron",
  "lisis",
  "lisol",
  "lista",
  "litar",
  "litio",
  "litis",
  "litre",
  "litro",
  "lituo",
  "liudo",
  "livor",
  "llaca",
  "llaga",
  "llama",
  "llana",
  "llano",
  "llapa",
  "llave",
  "lleco",
  "llega",
  "llena",
  "lleno",
  "llera",
  "lleva",
  "lloro",
  "llosa",
  "lobby",
  "local",
  "locha",
  "loche",
  "locro",
  "lodra",
  "lodon",
  "logar",
  "logia",
  "logis",
  "logos",
  "logro",
  "loica",
  "loina",
  "lolio",
  "lomba",
  "lombo",
  "lonco",
  "longa",
  "longo",
  "lonja",
  "lorza",
  "losar",
  "loteo",
  "lucha",
  "luche",
  "lucia",
  "lucio",
  "lucir",
  "lucro",
  "ludia",
  "ludio",
  "ludir",
  "luego",
  "lueñe",
  "lugar",
  "lugre",
  "luisa",
  "lujar",
  "lumbo",
  "lumen",
  "lumia",
  "lunar",
  "lunch",
  "lunel",
  "lunes",
  "lunfa",
  "lupia",
  "lupus",
  "lurte",
  "lusco",
  "luvia",
  "luxar",
  "labil",
  "lapiz",
  "laser",
  "latex",
  "lemur",
  "liber",
  "lider",
  "linea",
  "lineo",
  "lutea",
  "luteo",
  "mable",
  "macal",
  "macar",
  "maceo",
  "macha",
  "machi",
  "macho",
  "machi",
  "macia",
  "macis",
  "macla",
  "macro",
  "macua",
  "macio",
  "macon",
  "mador",
  "madre",
  "maesa",
  "maese",
  "maeso",
  "mafia",
  "magia",
  "magma",
  "magno",
  "magra",
  "magro",
  "mague",
  "magin",
  "mahon",
  "majal",
  "majar",
  "malar",
  "malla",
  "mallo",
  "malta",
  "malva",
  "malon",
  "mamar",
  "mambo",
  "mambi",
  "mamey",
  "mamut",
  "mamia",
  "mamon",
  "mamua",
  "manal",
  "manar",
  "manco",
  "manda",
  "mando",
  "mandi",
  "manea",
  "manes",
  "manga",
  "mango",
  "manir",
  "manso",
  "manta",
  "manto",
  "mania",
  "manus",
  "maori",
  "mapeo",
  "maque",
  "maqui",
  "marca",
  "marco",
  "marea",
  "mareo",
  "marga",
  "marlo",
  "marra",
  "marro",
  "marso",
  "marta",
  "marte",
  "marzo",
  "maria",
  "maron",
  "masar",
  "maslo",
  "maste",
  "masto",
  "masia",
  "mason",
  "matar",
  "mateo",
  "matiz",
  "matul",
  "maton",
  "maula",
  "maure",
  "mauro",
  "mayal",
  "mayar",
  "mayor",
  "mazar",
  "maido",
  "mbaya",
  "meada",
  "meado",
  "meaja",
  "meano",
  "meato",
  "mecer",
  "mecha",
  "media",
  "medio",
  "medir",
  "medra",
  "medro",
  "meigo",
  "mejer",
  "mejor",
  "melar",
  "melca",
  "melga",
  "melgo",
  "melis",
  "mella",
  "melsa",
  "melva",
  "melon",
  "memez",
  "menar",
  "menda",
  "meneo",
  "menge",
  "menor",
  "menos",
  "menso",
  "mensu",
  "menta",
  "mente",
  "menes",
  "merar",
  "merca",
  "merey",
  "mergo",
  "merla",
  "merlo",
  "merma",
  "mesar",
  "mesmo",
  "mesta",
  "mesto",
  "meson",
  "metad",
  "metal",
  "meter",
  "metra",
  "metro",
  "meyor",
  "miaja",
  "micer",
  "micha",
  "miche",
  "micho",
  "micra",
  "micro",
  "miedo",
  "miera",
  "migar",
  "milla",
  "millo",
  "milpa",
  "milan",
  "mimar",
  "minal",
  "minar",
  "minaz",
  "minga",
  "mingo",
  "minio",
  "minue",
  "mioma",
  "miope",
  "mirar",
  "mirla",
  "mirlo",
  "mirra",
  "mirto",
  "mirza",
  "miron",
  "misal",
  "misar",
  "misil",
  "misio",
  "mismo",
  "misto",
  "mitad",
  "mitin",
  "mitra",
  "mitan",
  "miton",
  "miura",
  "mixta",
  "mixto",
  "miñon",
  "moare",
  "moble",
  "mocar",
  "mocha",
  "moche",
  "mocho",
  "mocil",
  "modal",
  "modem",
  "modio",
  "mofar",
  "mogol",
  "mogon",
  "mohin",
  "mohur",
  "mojar",
  "mojel",
  "mojil",
  "mojon",
  "molar",
  "molde",
  "moler",
  "molla",
  "molle",
  "molsa",
  "molso",
  "molon",
  "momia",
  "momio",
  "monda",
  "mondo",
  "monfi",
  "monga",
  "mongo",
  "mongo",
  "monja",
  "monje",
  "monta",
  "monte",
  "monto",
  "monis",
  "moral",
  "morar",
  "morbo",
  "morca",
  "morfa",
  "morga",
  "morir",
  "morra",
  "morro",
  "morsa",
  "morse",
  "moron",
  "mosca",
  "mosco",
  "moste",
  "mosto",
  "mosen",
  "motel",
  "motil",
  "motor",
  "motin",
  "moton",
  "mover",
  "moxte",
  "moñon",
  "muare",
  "mucho",
  "mudar",
  "mudez",
  "mueca",
  "muela",
  "muelo",
  "muera",
  "mueso",
  "mufla",
  "mufti",
  "mugar",
  "mugir",
  "mugor",
  "mugre",
  "mujer",
  "mular",
  "mulla",
  "mullo",
  "mulso",
  "multa",
  "mundo",
  "mural",
  "murar",
  "murga",
  "muria",
  "murta",
  "murto",
  "musar",
  "musco",
  "museo",
  "musgo",
  "muslo",
  "mutar",
  "mutis",
  "mutro",
  "mutua",
  "mutuo",
  "muñir",
  "muñon",
  "misil",
  "moreo",
  "movil",
  "mugil",
  "mujol",
  "muleo",
  "Airon",
  "Algol",
  "Anton",
  "Araña",
  "Aries",
  "Arras",
  "Babia",
  "Bamba",
  "Barba",
  "Bañon",
  "Bueno",
  "Cabra",
  "Casio",
  "Chile",
  "Cobos",
  "Colon",
  "Coria",
  "Coran",
  "Cesar",
  "D.D.T",
  "David",
  "Diana",
  "Edipo",
  "Ester",
  "Fraga",
  "India",
  "Japon",
  "Jauja",
  "Jesus",
  "Jorge",
  "Judea",
  "Libra",
  "Lopez",
  "Malta",
  "Marta",
  "Marte",
  "Maria",
  "Mateo",
  "Mesta",
  "Mingo",
  "Morse",
  "Pablo",
  "Paris",
  "Paris",
  "Pavia",
  "Picio",
  "Pinto",
  "Quico",
  "Rengo",
  "Riego",
  "Rodas",
  "Romeo",
  "Roque",
  "Rusia",
  "Satan",
  "Seltz",
  "Sirio",
  "Tauro",
  "Troya",
  "Tunez",
  "Urias",
  "Venus",
  "Verbo",
  "Virgo",
  "nabab",
  "nabal",
  "nabar",
  "nabla",
  "nacer",
  "nacho",
  "nacre",
  "nadal",
  "nadar",
  "nadga",
  "nadie",
  "nadir",
  "nafra",
  "nafta",
  "nagua",
  "nahoa",
  "nahua",
  "naife",
  "naipe",
  "naire",
  "nalca",
  "nalga",
  "nanay",
  "nance",
  "nansa",
  "nansu",
  "napea",
  "napeo",
  "naque",
  "narco",
  "nardo",
  "nares",
  "nariz",
  "narra",
  "nasal",
  "nason",
  "natal",
  "natri",
  "natio",
  "nauta",
  "naval",
  "navio",
  "nebel",
  "nebli",
  "nebro",
  "necio",
  "negar",
  "negra",
  "negro",
  "negus",
  "neldo",
  "nemeo",
  "nemon",
  "nenia",
  "neron",
  "nesga",
  "neuma",
  "nevar",
  "niara",
  "niazo",
  "nicho",
  "nicle",
  "nicol",
  "nidal",
  "nidio",
  "niego",
  "nieto",
  "nieve",
  "nigua",
  "nilad",
  "nilon",
  "nimbo",
  "nimio",
  "ninfa",
  "ninfo",
  "ninot",
  "nioto",
  "nipis",
  "nipos",
  "nipon",
  "niqui",
  "niste",
  "nitor",
  "nitro",
  "nivel",
  "nixte",
  "niñez",
  "noble",
  "noche",
  "nocir",
  "nocla",
  "nodal",
  "noema",
  "nogal",
  "nolit",
  "nomon",
  "nomas",
  "nones",
  "nonio",
  "nopal",
  "noque",
  "noray",
  "noria",
  "norma",
  "norte",
  "notar",
  "notro",
  "noval",
  "novar",
  "novel",
  "novio",
  "noven",
  "nubio",
  "nublo",
  "nuche",
  "nucir",
  "nuera",
  "nueso",
  "nueva",
  "nueve",
  "nuevo",
  "nueza",
  "numen",
  "nunca",
  "nutra",
  "nacar",
  "nadir",
  "niveo",
  "nubil",
  "ñandu",
  "ñanga",
  "ñango",
  "ñaque",
  "ñecla",
  "ñengo",
  "ñeque",
  "ñinga",
  "ñique",
  "ñisca",
  "ñocha",
  "ñoclo",
  "ñongo",
  "ñoqui",
  "ñorbo",
  "ñoñez",
  "ñublo",
  "oasis",
  "obeso",
  "oblea",
  "obrar",
  "obvio",
  "ocapi",
  "ocaso",
  "ocelo",
  "ocena",
  "ociar",
  "ocote",
  "ocuje",
  "ocume",
  "ocumo",
  "odeon",
  "odiar",
  "oeste",
  "ofita",
  "ogaño",
  "ohmio",
  "oidor",
  "ojala",
  "ojear",
  "ojera",
  "ojete",
  "ojito",
  "ojiva",
  "ojoso",
  "ojota",
  "ojudo",
  "okapi",
  "olaje",
  "olear",
  "oliva",
  "olivo",
  "ollao",
  "ollar",
  "olote",
  "olura",
  "omaso",
  "omega",
  "omero",
  "omeya",
  "omiso",
  "ondeo",
  "ondra",
  "onoto",
  "opaco",
  "opado",
  "opimo",
  "optar",
  "oraje",
  "orate",
  "orden",
  "orear",
  "oreja",
  "orfre",
  "orgia",
  "orgia",
  "oribe",
  "orina",
  "oriol",
  "orive",
  "orlar",
  "ornar",
  "oroya",
  "oruga",
  "orujo",
  "orzar",
  "osado",
  "osear",
  "osera",
  "osero",
  "oseta",
  "osmio",
  "ososo",
  "ostia",
  "ostra",
  "ostro",
  "osudo",
  "osuno",
  "otate",
  "otear",
  "otero",
  "otoba",
  "otoño",
  "ovado",
  "oveja",
  "overa",
  "overo",
  "ovino",
  "ovoso",
  "oxear",
  "ozona",
  "ozono",
  "oible",
  "oidio",
  "oislo",
  "obelo",
  "obice",
  "obito",
  "obolo",
  "onice",
  "opalo",
  "opera",
  "ovalo",
  "ovido",
  "ovolo",
  "ovulo",
  "oxido",
  "pablo",
  "pacay",
  "pacer",
  "pacha",
  "pacho",
  "pacha",
  "pacto",
  "pacon",
  "padre",
  "pafio",
  "pagar",
  "pagel",
  "pagro",
  "pagua",
  "pahua",
  "paico",
  "paila",
  "paina",
  "pairo",
  "pajar",
  "pajea",
  "pajel",
  "pajil",
  "pajuz",
  "pajon",
  "palay",
  "palca",
  "palco",
  "palia",
  "palio",
  "palla",
  "palma",
  "palmo",
  "palor",
  "palpi",
  "palpo",
  "palta",
  "palto",
  "palon",
  "pamba",
  "pampa",
  "pamue",
  "panal",
  "panca",
  "panco",
  "panda",
  "pando",
  "panel",
  "panga",
  "panji",
  "pansa",
  "panty",
  "panul",
  "panza",
  "papal",
  "papar",
  "papaz",
  "papel",
  "papin",
  "papon",
  "papua",
  "paral",
  "parao",
  "parar",
  "parca",
  "parce",
  "parco",
  "pardo",
  "pared",
  "parel",
  "pareo",
  "pargo",
  "paria",
  "pario",
  "parir",
  "parla",
  "parne",
  "parra",
  "parro",
  "parsi",
  "parte",
  "parto",
  "parva",
  "parvo",
  "pasar",
  "pasco",
  "paseo",
  "pasil",
  "pasma",
  "pasmo",
  "pasta",
  "paste",
  "pasto",
  "patao",
  "patas",
  "patax",
  "patay",
  "pateo",
  "patio",
  "patan",
  "patin",
  "patio",
  "paton",
  "pauji",
  "pausa",
  "pauta",
  "pavor",
  "paves",
  "pavia",
  "pavon",
  "payar",
  "payes",
  "pañal",
  "pañil",
  "pañol",
  "peaje",
  "peana",
  "peaña",
  "pebre",
  "pecar",
  "pecha",
  "peche",
  "pecho",
  "pecio",
  "pedal",
  "pedio",
  "pedir",
  "pedro",
  "pegar",
  "pegon",
  "peina",
  "peine",
  "pejin",
  "pelar",
  "pelde",
  "pelea",
  "pella",
  "pello",
  "pelma",
  "pelta",
  "pelvi",
  "pelon",
  "penal",
  "penar",
  "penca",
  "penco",
  "penol",
  "pepla",
  "peplo",
  "pepon",
  "peral",
  "perca",
  "perla",
  "perle",
  "perna",
  "perno",
  "perol",
  "perra",
  "perro",
  "persa",
  "perta",
  "pesar",
  "pesca",
  "pesce",
  "pesga",
  "pesgo",
  "pesia",
  "pesor",
  "peste",
  "petar",
  "petra",
  "peuco",
  "peumo",
  "pezon",
  "peñol",
  "peñon",
  "peuco",
  "piada",
  "piano",
  "piara",
  "pibil",
  "pical",
  "picar",
  "picea",
  "picha",
  "piche",
  "pichi",
  "picho",
  "pichi",
  "picor",
  "picon",
  "piden",
  "pidon",
  "piejo",
  "pieza",
  "pifia",
  "pigre",
  "pigro",
  "pihua",
  "pilar",
  "pilca",
  "pilla",
  "pillo",
  "pilme",
  "pilon",
  "pinar",
  "pinga",
  "pingo",
  "pinna",
  "pinol",
  "pinta",
  "pinto",
  "pinza",
  "piojo",
  "piola",
  "pipar",
  "pipil",
  "pipon",
  "pique",
  "pique",
  "piral",
  "pirar",
  "pirca",
  "pirco",
  "pirla",
  "piron",
  "pisar",
  "pisca",
  "pisco",
  "pispa",
  "pista",
  "piste",
  "pisto",
  "pison",
  "pitao",
  "pitar",
  "pitio",
  "pitio",
  "piton",
  "piune",
  "piure",
  "pixel",
  "pizca",
  "pizco",
  "pizza",
  "piñal",
  "piñen",
  "piñon",
  "placa",
  "plaga",
  "plana",
  "plano",
  "plata",
  "plato",
  "plato",
  "playa",
  "playo",
  "plaza",
  "plazo",
  "plebe",
  "pleca",
  "plena",
  "pleno",
  "pleon",
  "plepa",
  "plexo",
  "plica",
  "plomo",
  "pluma",
  "pobra",
  "pobre",
  "pocha",
  "pocho",
  "podar",
  "poder",
  "podio",
  "podre",
  "podon",
  "poema",
  "poeta",
  "poisa",
  "poise",
  "polar",
  "polca",
  "polea",
  "polen",
  "poleo",
  "polio",
  "polir",
  "polla",
  "pollo",
  "polvo",
  "polin",
  "pomar",
  "pompa",
  "pompo",
  "ponci",
  "poner",
  "pongo",
  "ponto",
  "popar",
  "popel",
  "popes",
  "porco",
  "porno",
  "porra",
  "porro",
  "porta",
  "porte",
  "posar",
  "posca",
  "posma",
  "posta",
  "poste",
  "poson",
  "potar",
  "potra",
  "potro",
  "poyal",
  "poyar",
  "pozal",
  "pozol",
  "poino",
  "prado",
  "pravo",
  "praza",
  "prear",
  "preda",
  "presa",
  "preso",
  "prest",
  "prima",
  "primo",
  "prion",
  "prior",
  "prisa",
  "proal",
  "probo",
  "proco",
  "proel",
  "profe",
  "prole",
  "prono",
  "prora",
  "prosa",
  "prois",
  "proiz",
  "pruna",
  "pruno",
  "puado",
  "pubes",
  "pubis",
  "pucha",
  "pucho",
  "pucia",
  "pudio",
  "pudir",
  "pudor",
  "pudin",
  "pugna",
  "pujar",
  "pujes",
  "pulga",
  "pulir",
  "pulla",
  "pulpa",
  "pulpo",
  "pulso",
  "pumba",
  "punar",
  "punga",
  "punir",
  "punta",
  "punto",
  "punzo",
  "pupar",
  "purga",
  "purin",
  "puspo",
  "puyar",
  "puyon",
  "puzle",
  "puzol",
  "puñal",
  "puñar",
  "puñir",
  "pater",
  "pesol",
  "picea",
  "piceo",
  "pileo",
  "pivot",
  "polex",
  "pomez",
  "poney",
  "puber",
  "pugil",
  "quark",
  "queco",
  "queda",
  "quedo",
  "queja",
  "quejo",
  "quema",
  "quemi",
  "quena",
  "quera",
  "queso",
  "quico",
  "quien",
  "quier",
  "quijo",
  "quila",
  "quilo",
  "quima",
  "quimo",
  "quina",
  "quino",
  "quipa",
  "quipu",
  "quisa",
  "quita",
  "quite",
  "quito",
  "quivi",
  "quiza",
  "quiño",
  "rabal",
  "rabel",
  "rabeo",
  "rabia",
  "rabil",
  "rabon",
  "racel",
  "racha",
  "racor",
  "radal",
  "radar",
  "radio",
  "radio",
  "radon",
  "rafal",
  "rafez",
  "rafia",
  "ragua",
  "rahez",
  "raido",
  "raijo",
  "rajar",
  "rajon",
  "ralea",
  "rallo",
  "rally",
  "ramal",
  "ramio",
  "rampa",
  "ramon",
  "randa",
  "rango",
  "rapar",
  "rapaz",
  "rapta",
  "rapto",
  "raque",
  "rasar",
  "rasca",
  "rasel",
  "rasgo",
  "raspa",
  "rateo",
  "ratio",
  "raton",
  "rauco",
  "rauda",
  "raudo",
  "rauli",
  "rauta",
  "rayar",
  "rayon",
  "razar",
  "razia",
  "razon",
  "raido",
  "reala",
  "reata",
  "reato",
  "reble",
  "rebol",
  "rebus",
  "recel",
  "recio",
  "recle",
  "recre",
  "recta",
  "recto",
  "recua",
  "redar",
  "redel",
  "redil",
  "redol",
  "redor",
  "redro",
  "refez",
  "regar",
  "regio",
  "regir",
  "regla",
  "rehen",
  "rehus",
  "reina",
  "reino",
  "rejal",
  "rejin",
  "rejon",
  "rejus",
  "relax",
  "relej",
  "reloj",
  "relso",
  "relva",
  "remar",
  "renal",
  "renco",
  "renda",
  "renga",
  "rengo",
  "renil",
  "renio",
  "renta",
  "rento",
  "reoca",
  "reojo",
  "resma",
  "resol",
  "respe",
  "resta",
  "resto",
  "retal",
  "retar",
  "retel",
  "retor",
  "retro",
  "reten",
  "retin",
  "reuma",
  "rever",
  "reves",
  "reyar",
  "rezar",
  "rezno",
  "rezon",
  "reñir",
  "reuma",
  "riada",
  "ricia",
  "ricio",
  "riego",
  "riera",
  "rifar",
  "rifle",
  "rigor",
  "rigue",
  "rilar",
  "rimar",
  "rinde",
  "rioja",
  "ripia",
  "ripio",
  "risca",
  "risco",
  "rispa",
  "rispo",
  "ritmo",
  "riton",
  "rival",
  "rizal",
  "rizar",
  "rizon",
  "riñon",
  "roano",
  "robar",
  "robda",
  "robla",
  "roble",
  "robot",
  "robra",
  "robre",
  "robin",
  "rocha",
  "rocho",
  "rocin",
  "rocio",
  "rodal",
  "rodar",
  "rodea",
  "rodeo",
  "rodil",
  "rodio",
  "roela",
  "roete",
  "rogar",
  "rojal",
  "rojez",
  "rolar",
  "rolde",
  "roleo",
  "rolla",
  "rollo",
  "rombo",
  "romeo",
  "roman",
  "romin",
  "ronca",
  "ronce",
  "ronco",
  "ronda",
  "rondo",
  "ronza",
  "ropon",
  "roque",
  "rorar",
  "rorro",
  "rosal",
  "rosar",
  "rosca",
  "rosco",
  "rosjo",
  "roson",
  "rotal",
  "rotar",
  "roten",
  "rotor",
  "rouge",
  "rozar",
  "rozno",
  "rozon",
  "roido",
  "roñal",
  "roñar",
  "roñia",
  "ruana",
  "ruano",
  "rubia",
  "rubio",
  "rublo",
  "rubor",
  "rubro",
  "rubin",
  "rucar",
  "ruche",
  "rucho",
  "rucio",
  "rueca",
  "rueda",
  "ruedo",
  "ruego",
  "ruejo",
  "rueño",
  "rufon",
  "rugar",
  "rugby",
  "rugir",
  "ruido",
  "ruina",
  "rular",
  "rumba",
  "rumbo",
  "rumia",
  "rumor",
  "rungo",
  "rupia",
  "rural",
  "rurru",
  "rusco",
  "rusel",
  "rusia",
  "rutar",
  "rutel",
  "ruñar",
  "rameo",
  "retor",
  "rimel",
  "rodeo",
  "roseo",
  "rubeo",
  "sabeo",
  "saber",
  "sabio",
  "sable",
  "sabor",
  "sabre",
  "sacar",
  "sacho",
  "sacio",
  "sacra",
  "sacre",
  "sacro",
  "sacon",
  "saeta",
  "saeti",
  "safir",
  "sagaz",
  "sajar",
  "sajia",
  "sajon",
  "salar",
  "salaz",
  "salce",
  "saldo",
  "salea",
  "salep",
  "salga",
  "salio",
  "salir",
  "salma",
  "salmo",
  "salol",
  "salpa",
  "salsa",
  "salso",
  "salto",
  "salud",
  "salva",
  "salve",
  "salvo",
  "salin",
  "salon",
  "samba",
  "sambo",
  "samio",
  "sampa",
  "saman",
  "sanar",
  "sanco",
  "sango",
  "sanie",
  "sansa",
  "sanso",
  "santa",
  "santo",
  "saque",
  "sarao",
  "sarda",
  "sarde",
  "sardo",
  "sarga",
  "sargo",
  "saria",
  "sarna",
  "sarro",
  "sarta",
  "sarza",
  "sarzo",
  "saran",
  "satis",
  "saten",
  "satin",
  "sauce",
  "saudi",
  "sauna",
  "savia",
  "sayal",
  "sayon",
  "sazon",
  "saino",
  "sauco",
  "secar",
  "secta",
  "secua",
  "secon",
  "sedal",
  "sedar",
  "sedan",
  "segar",
  "segri",
  "segur",
  "segun",
  "seibo",
  "seibo",
  "seico",
  "seise",
  "sello",
  "selva",
  "semen",
  "semis",
  "senda",
  "senil",
  "sepia",
  "septo",
  "serba",
  "serbo",
  "serie",
  "serio",
  "serna",
  "serpa",
  "servo",
  "seron",
  "seseo",
  "sesga",
  "sesgo",
  "sesma",
  "sesmo",
  "sesen",
  "setal",
  "seudo",
  "sexma",
  "sexmo",
  "sexta",
  "sexto",
  "seibo",
  "señal",
  "señor",
  "short",
  "sibil",
  "siclo",
  "sidra",
  "siega",
  "siena",
  "sieso",
  "siete",
  "sifue",
  "sifon",
  "sigla",
  "siglo",
  "sigma",
  "signo",
  "sigua",
  "silba",
  "silbo",
  "silfo",
  "silga",
  "silla",
  "silva",
  "simia",
  "simio",
  "simpa",
  "simon",
  "simun",
  "singa",
  "sirga",
  "sirgo",
  "sirio",
  "sirle",
  "sirte",
  "sisal",
  "sisar",
  "sisca",
  "siseo",
  "sismo",
  "sison",
  "sitio",
  "sobar",
  "sobeo",
  "sobra",
  "sobre",
  "sobon",
  "socaz",
  "soche",
  "socio",
  "sodio",
  "soeza",
  "sogun",
  "solar",
  "solaz",
  "solen",
  "soleo",
  "soler",
  "solea",
  "solfa",
  "solio",
  "solla",
  "sollo",
  "solen",
  "sonar",
  "sonda",
  "sonio",
  "sonso",
  "sonto",
  "sopar",
  "sopie",
  "soplo",
  "sopor",
  "sopon",
  "sorba",
  "sorbo",
  "sorce",
  "sorda",
  "sordo",
  "sorgo",
  "sorna",
  "sorra",
  "sosal",
  "sosar",
  "sosia",
  "sotar",
  "sotil",
  "sotol",
  "sovoz",
  "soñar",
  "sport",
  "spray",
  "stand",
  "stock",
  "suabo",
  "suato",
  "suave",
  "subeo",
  "subir",
  "subte",
  "suche",
  "sucio",
  "sucre",
  "sudar",
  "sudor",
  "sueco",
  "suela",
  "suelo",
  "sueno",
  "suero",
  "suevo",
  "sueño",
  "sufra",
  "suido",
  "suita",
  "suite",
  "suiza",
  "suizo",
  "sulco",
  "sulla",
  "sumar",
  "sumir",
  "sunco",
  "supra",
  "sural",
  "surco",
  "surto",
  "susto",
  "sutil",
  "sutas",
  "suzon",
  "saxeo",
  "sesil",
  "silex",
  "simil",
  "soleo",
  "soror",
  "super",
  "tabal",
  "tabea",
  "tabes",
  "tabla",
  "tabor",
  "tabon",
  "tacar",
  "tacha",
  "tacho",
  "tacto",
  "tacon",
  "tafia",
  "tafur",
  "tafon",
  "tagua",
  "tahur",
  "taifa",
  "taiga",
  "taima",
  "taina",
  "taira",
  "taire",
  "taita",
  "tajar",
  "tajea",
  "tajon",
  "talar",
  "talco",
  "taled",
  "talgo",
  "talio",
  "talla",
  "talle",
  "tallo",
  "talma",
  "talpa",
  "talud",
  "talan",
  "talin",
  "talon",
  "tamal",
  "tamba",
  "tambo",
  "tamil",
  "tamiz",
  "tamul",
  "tanda",
  "tanga",
  "tango",
  "tanka",
  "tanor",
  "tanto",
  "tanza",
  "tapar",
  "tapeo",
  "tapia",
  "tapir",
  "tapis",
  "tapiz",
  "tapin",
  "tapon",
  "taque",
  "taque",
  "tarar",
  "taray",
  "tarca",
  "tarco",
  "tarde",
  "tardo",
  "tarea",
  "tarja",
  "tarma",
  "tarot",
  "tarra",
  "tarro",
  "tarso",
  "tarta",
  "tarin",
  "tasar",
  "tasca",
  "tasco",
  "tasio",
  "tasto",
  "tatas",
  "tauca",
  "taula",
  "tauro",
  "taxon",
  "tazar",
  "tazon",
  "taina",
  "taino",
  "tañar",
  "tañer",
  "tauca",
  "teame",
  "tebeo",
  "techo",
  "tecla",
  "tecle",
  "tecol",
  "tedio",
  "tegeo",
  "tegua",
  "tegue",
  "tejar",
  "tejer",
  "tejon",
  "telar",
  "telon",
  "temer",
  "temor",
  "tempo",
  "tenaz",
  "tenca",
  "tener",
  "tenia",
  "tenis",
  "tenor",
  "tenso",
  "tenue",
  "teoso",
  "terco",
  "terma",
  "termo",
  "terna",
  "terne",
  "terno",
  "terso",
  "tesar",
  "tesis",
  "tesla",
  "testa",
  "teste",
  "teson",
  "tetar",
  "tetra",
  "tetro",
  "teton",
  "texto",
  "teina",
  "teñir",
  "tiaca",
  "tiara",
  "tibar",
  "tibia",
  "tibio",
  "tibor",
  "tieso",
  "tifus",
  "tifon",
  "tigra",
  "tigre",
  "tilde",
  "tilia",
  "tilla",
  "tillo",
  "tilma",
  "tilin",
  "timar",
  "timba",
  "timbo",
  "timbo",
  "timol",
  "timpa",
  "timon",
  "tinca",
  "tinge",
  "tinta",
  "tinte",
  "tinto",
  "tiple",
  "tipoi",
  "tipoy",
  "tipoi",
  "tique",
  "tiqui",
  "tirar",
  "tirio",
  "tirso",
  "tirte",
  "tiron",
  "tisis",
  "tiste",
  "titar",
  "titeo",
  "titan",
  "tizna",
  "tizne",
  "tizon",
  "tlaco",
  "tobar",
  "tocar",
  "toche",
  "tocho",
  "tocia",
  "tocio",
  "tocte",
  "tocia",
  "tocon",
  "todia",
  "toesa",
  "tojal",
  "toldo",
  "tolla",
  "tollo",
  "tolmo",
  "tolva",
  "tolon",
  "tomar",
  "tomin",
  "tomon",
  "tonal",
  "tonar",
  "tonca",
  "tondo",
  "tonel",
  "tonga",
  "tongo",
  "tonto",
  "topar",
  "topia",
  "topil",
  "topon",
  "toque",
  "toqui",
  "toral",
  "torca",
  "torce",
  "torco",
  "torda",
  "tordo",
  "toreo",
  "torga",
  "torgo",
  "toril",
  "torio",
  "tormo",
  "torna",
  "torno",
  "torpe",
  "torre",
  "torso",
  "torta",
  "torva",
  "torvo",
  "tores",
  "toron",
  "tosca",
  "tosco",
  "toser",
  "total",
  "tozal",
  "tozar",
  "toñil",
  "traba",
  "trabe",
  "traca",
  "trace",
  "traer",
  "trago",
  "traje",
  "trama",
  "tramo",
  "trapa",
  "trape",
  "trapo",
  "traro",
  "trata",
  "trato",
  "travo",
  "traza",
  "trazo",
  "trebo",
  "trece",
  "trefe",
  "treja",
  "tremo",
  "trena",
  "treno",
  "trepa",
  "trepe",
  "treta",
  "trial",
  "triar",
  "tribu",
  "triga",
  "trigo",
  "trile",
  "trino",
  "tripa",
  "tripe",
  "trisa",
  "triza",
  "troco",
  "troja",
  "troje",
  "trola",
  "trole",
  "trona",
  "trono",
  "tropa",
  "tropo",
  "trote",
  "trova",
  "trovo",
  "troya",
  "troza",
  "trozo",
  "truca",
  "truco",
  "trufa",
  "truja",
  "trusa",
  "trust",
  "tucan",
  "tucia",
  "tudel",
  "tueca",
  "tueco",
  "tuera",
  "tuero",
  "tuina",
  "tulio",
  "tulpa",
  "tumba",
  "tumbo",
  "tumor",
  "tunal",
  "tunar",
  "tunca",
  "tunco",
  "tunda",
  "tunjo",
  "tunta",
  "tupir",
  "tupin",
  "turar",
  "turba",
  "turca",
  "turco",
  "turma",
  "turno",
  "turra",
  "turro",
  "turon",
  "tusar",
  "tusca",
  "tusco",
  "tuson",
  "tuteo",
  "tutor",
  "tutia",
  "tacet",
  "talea",
  "telex",
  "tibar",
  "tinea",
  "torax",
  "totem",
  "tunel",
  "ucase",
  "uebos",
  "ufano",
  "ujier",
  "ulaga",
  "ulala",
  "ulano",
  "ulema",
  "ultra",
  "umbra",
  "umbro",
  "umero",
  "uncia",
  "uncir",
  "ungir",
  "union",
  "untar",
  "upupa",
  "urape",
  "urato",
  "urdir",
  "urgir",
  "urubu",
  "urucu",
  "uruga",
  "usado",
  "usaje",
  "usier",
  "usina",
  "usted",
  "usual",
  "usura",
  "uvada",
  "uvate",
  "uvero",
  "uviar",
  "uñado",
  "uñate",
  "uñero",
  "uñeta",
  "uñoso",
  "ulula",
  "unico",
  "urico",
  "utero",
  "uvula",
  "vacar",
  "vacuo",
  "vacio",
  "vagar",
  "vagon",
  "vahar",
  "vaina",
  "valar",
  "valer",
  "valgo",
  "valla",
  "valle",
  "valor",
  "valse",
  "valva",
  "valia",
  "valon",
  "vamos",
  "vapor",
  "varal",
  "varar",
  "varea",
  "vareo",
  "varga",
  "vario",
  "variz",
  "varon",
  "vasar",
  "vasco",
  "vasto",
  "vatio",
  "vaida",
  "vedar",
  "vejar",
  "vejez",
  "velar",
  "velay",
  "velis",
  "veliz",
  "vello",
  "veloz",
  "velon",
  "venal",
  "venda",
  "vendo",
  "vendi",
  "venia",
  "venir",
  "venta",
  "venus",
  "veras",
  "veraz",
  "verba",
  "verbo",
  "verde",
  "verga",
  "verge",
  "veril",
  "verja",
  "verme",
  "vermu",
  "verso",
  "veste",
  "vetar",
  "veton",
  "vezar",
  "viada",
  "viaje",
  "vichy",
  "vicia",
  "vicio",
  "victo",
  "vidro",
  "vieja",
  "viejo",
  "viesa",
  "vigor",
  "vigia",
  "villa",
  "vilos",
  "vinal",
  "vinar",
  "vinca",
  "vinco",
  "vinta",
  "viola",
  "viral",
  "virar",
  "virgo",
  "viril",
  "virio",
  "virol",
  "virus",
  "viron",
  "visar",
  "visco",
  "visir",
  "visor",
  "vista",
  "visto",
  "vison",
  "vital",
  "vitar",
  "vitre",
  "viuda",
  "viudo",
  "vivac",
  "vivar",
  "vivaz",
  "vivez",
  "vivir",
  "voace",
  "vocal",
  "voceo",
  "vodca",
  "vodka",
  "voila",
  "volar",
  "volea",
  "voleo",
  "volvo",
  "voraz",
  "voseo",
  "votar",
  "votri",
  "vuelo",
  "vueso",
  "vulgo",
  "vulto",
  "vulva",
  "vusco",
  "vater",
  "video",
  "vireo",
  "vitor",
  "vomer",
  "weber",
  "weber",
  "xenon",
  "yacal",
  "yacer",
  "yacio",
  "yagua",
  "yaiti",
  "yamao",
  "yambo",
  "yanta",
  "yapar",
  "yaque",
  "yarda",
  "yarey",
  "yatay",
  "yatai",
  "yedgo",
  "yedra",
  "yegua",
  "yelgo",
  "yelmo",
  "yente",
  "yeral",
  "yerba",
  "yermo",
  "yerna",
  "yerno",
  "yerra",
  "yerro",
  "yersi",
  "yerto",
  "yervo",
  "yesal",
  "yesar",
  "yesca",
  "yeson",
  "yezgo",
  "yogar",
  "yogui",
  "yogur",
  "yoqui",
  "yucal",
  "yumbo",
  "yunga",
  "yunta",
  "yunto",
  "yuras",
  "yuyal",
  "zabra",
  "zabro",
  "zaceo",
  "zafar",
  "zafio",
  "zafir",
  "zafra",
  "zafre",
  "zafio",
  "zafon",
  "zagal",
  "zagua",
  "zahen",
  "zahon",
  "zaida",
  "zaina",
  "zaino",
  "zajon",
  "zalbo",
  "zalea",
  "zaleo",
  "zamba",
  "zambo",
  "zampa",
  "zanca",
  "zanco",
  "zanga",
  "zanja",
  "zapar",
  "zaque",
  "zarbo",
  "zarco",
  "zarja",
  "zarpa",
  "zarza",
  "zarzo",
  "zebra",
  "zegri",
  "zendo",
  "zenit",
  "zoclo",
  "zofra",
  "zoilo",
  "zoizo",
  "zolle",
  "zombi",
  "zompo",
  "zonal",
  "zonda",
  "zonto",
  "zonzo",
  "zopas",
  "zoque",
  "zorra",
  "zorro",
  "zotal",
  "zuavo",
  "zubia",
  "zueca",
  "zueco",
  "zuela",
  "zuiza",
  "zulla",
  "zumba",
  "zumbo",
  "zupia",
  "zurba",
  "zurda",
  "zurdo",
  "zureo",
  "zurra",
  "zuzar",
  "zuzon",
  "zuñir",
  "zejel",
];
